<template>
  <div class="mx-auto w-full max-w-9xl p-3 md:px-4 lg:p-8">
    <div v-if="$slots.heading">
      <slot name="heading" />
    </div>
    
    <slot />
  </div>
</template>